import React, { useState, useRef, useEffect, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners';
import './common.css';
import { useUser } from '../../contexts/userContext';
import eventBus from './eventBus';
import { useDispatch, useSelector } from 'react-redux';
import { selectCityEvent } from '../../shared/events/product.event';
import { selectGeo, selectShowCityPopup, setGeoInfo, setIsPincodeLoading, setShowCityPopup } from '../../redux/slices/pincode';
import { GeoInfo } from '../../types';
import { useAddressManager } from '../../hooks/useAddressManager';
import { useApi } from '../../shared/api';
import { check_is_cityPopupLoading_enable, getIPAddress } from '../../shared/utils/utils';
import { SitePath } from '../../shared/constants';
import { useLocation } from 'react-router-dom';
import { allowedCityPopupVisibilityOnPath } from '../../siteConfiguration';
import { selectUtmCampaign } from '../../redux/slices/utm';
import "./style/cityPopup.css";
import { Message } from '../../shared/constants';

interface CityPopupProps { }

const CityPopup: React.FC<CityPopupProps> = () => {
    const API = useApi()
    const dispatch = useDispatch();
    const isCityPopupVisible = useSelector(selectShowCityPopup);
    const geoInfo = useSelector(selectGeo);
    const location = useLocation()
    const [searchTerm, setSearchTerm] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [isDetectingLocation, setIsDetectingLocation] = useState(false);
    const [cityDetected, setCityDetected] = useState(false);
    const pincodeInputRef = useRef<HTMLInputElement>(null);
    const { setcityName, city_name, fetchCsrfToken, user_id, setPincode } = useUser();
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    const utm_query = useSelector(selectUtmCampaign)
    const utmQuery = utm_query
    const { detectMyLocationAddress } = useAddressManager()
    // const isCityVisibleWithoutForce =  check_is_cityPopupLoading_enable();
    // console.log("isCityVisibleWithoutForce", isCityVisibleWithoutForce)

    // useEffect(()=>{
    //     if(isCityVisibleWithoutForce){
    //         dispatch(setIsPincodeLoading(false))
    //     }
    // }, [isCityVisibleWithoutForce])ok
    // Focus input when modal becomes visible
    useEffect(() => {
        if (isCityPopupVisible && pincodeInputRef.current) {
            pincodeInputRef.current.focus();
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isCityPopupVisible]);

    useEffect(() => {

        const fetchCityByPincode = async () => {

            if (searchTerm.length === 6) {
                try {
                    dispatch(setIsPincodeLoading(true));
                    dispatch(setShowCityPopup(false)); // Close modal while loading
                    const service_check = true
                    const response = await API.API_V1.address.getPincodeServiciability(searchTerm, service_check)

                    const data = response.data

                    if (response?.error) {
                        dispatch(setShowCityPopup(true)); // Reopen modal on error
                        dispatch(setIsPincodeLoading(false));

                        setError(Message.PINCODE_INVALID);
                        return;
                    }

                    const ip_address = await getIPAddress();

                    if (response) {
                        const geoData = data;
                        const geoInfo: GeoInfo = {
                            ipAddress: ip_address,
                            showCityPopup: false,
                            isLoading: false,
                            pincode: searchTerm,
                            isForceShow: false,
                            city: {
                                cityId: geoData.cityId,
                                cityName: geoData.city
                            },
                            state: {
                                stateId: geoData.stateId,
                                stateName: geoData.state
                            }
                        };


                        setcityName(data.city);
                        setPincode(searchTerm);
                        dispatch(setGeoInfo(geoInfo));
                        setCityDetected(true);
                        selectCityEvent(data.city, Number(searchTerm));
                        const userId = user_id;
                        const reqBody = {
                            pincode: searchTerm,
                            city: data.city,
                            locality: null,
                            user_id: userId,
                            user_agent: navigator.userAgent,
                            ip_address: ip_address
                        }

                        const saveLocationLog = await API.API_V1.address.postLocationLog(reqBody, utmQuery)
                        setSearchTerm('');
                    } else {
                        setError(Message.PINCODE_INVALID);
                        dispatch(setShowCityPopup(true)); // Reopen modal on error
                        dispatch(setIsPincodeLoading(false));
                    }
                } catch (error) {

                    setError(Message.PINCODE_CITY_ERROR);
                    dispatch(setShowCityPopup(true)); // Reopen modal on error
                    dispatch(setIsPincodeLoading(false));
                }
            }
        };

        fetchCityByPincode();
    }, [searchTerm]);

   
        const errorMessage = useMemo(()=>{
           const err = {
            title:"",
            description:""
           } 
        if(!error){
            return err 
        }
        const splittedString = error.split(".")
         
        err.title = splittedString[0];
        err.description = splittedString[1];

            return err
        
    },[error])

    const handlePincodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        const value = e.target.value;
        if (/^\d{0,6}$/.test(value)) {
            setSearchTerm(value);

            if (value.length < 6) {
                setError(Message.PINCODE_REQUIRED_MSG);
            } else {
                setError(null);
            }
        }
    };

    const handleDetectLocation = async () => {

        if (navigator.geolocation) {
            dispatch(setIsPincodeLoading(true));
            dispatch(setShowCityPopup(false)); // Close modal while loading
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    const addressDetails = await detectMyLocationAddress(latitude, longitude); // Call the function with coordinates
                    if (!addressDetails) {
                        alert("Failed to fetch your location.")
                        dispatch(setShowCityPopup(true));
                        dispatch(setIsPincodeLoading(false));
                        return
                    } else {
                        setSearchTerm(addressDetails.pincode);

                    }
                    setError(null)
                },
                // Error callback for handling permission denial and other errors
                (error) => {
                    // Stop the loader
                    dispatch(setIsPincodeLoading(false));
                    // Reopen the popup
                    dispatch(setShowCityPopup(true));

                    // Handle different types of geolocation errors
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            setError(Message.GEOLOCATION_ERROR);
                            break;
                        case error.POSITION_UNAVAILABLE:
                            setError(Message.GEOLOCATION_ERROR);
                            break;
                        case error.TIMEOUT:
                            setError(Message.GEOLOCATION_ERROR);
                            break;
                        default:
                            setError(Message.GEOLOCATION_ERROR);
                            break;
                    }
                },
                // Options for getCurrentPosition
                {
                    enableHighAccuracy: false,
                    timeout: 10000, // 10 seconds timeout
                    maximumAge: 0
                }
            );
        } else {
            // Browser doesn't support geolocation
            setError(Message.GEOLOCATION_ERROR);
            dispatch(setShowCityPopup(true));
        }
    };

    //control citypop visibility form here

    const isAllowedPath =
        allowedCityPopupVisibilityOnPath.includes(location.pathname) ||
        (location.pathname.includes("sell-") && allowedCityPopupVisibilityOnPath.includes('sell-'));

    if (!isAllowedPath && !geoInfo.isForceShow) {
        return null;
    }


    if ((!isCityPopupVisible && geoInfo.city.cityId && !geoInfo.isForceShow)) {

        return null;
    }



    return (
        <div className="popup-overlay">
            <div className="popup-content-city">
                {error && <>Error</>}
                <h1>Select Your City</h1>
                <button
                    disabled={geoInfo.isLoading}
                    onClick={(e) => {
                        e.preventDefault();
                        handleDetectLocation();
                    }}
                    className="location-button"
                // disabled={isDetectingLocation || cityDetected}
                >



                    <div className='d-flex align-items-center justify-content-center gap-2'>
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                        <p className="detect-location">Detect My Location</p>
                        {geoInfo.isLoading && <ClipLoader color="#3498db" size={20} />}
                    </div>



                </button>
                <p className="permission-location-heading">
                    We will need permission to use your device location.
                </p>
                <div className="or-line">
                    <hr className="line" />
                    <p className="or-title">or</p>
                    <hr className="line" />
                </div>
                <h3>Search Manually</h3>
                <input
                    type="text"
                    placeholder="Pincode"
                    name="pincode"
                    value={searchTerm}
                    onChange={handlePincodeChange}
                    maxLength={6}
                    ref={pincodeInputRef}
                    disabled={geoInfo.isLoading}
                />

                {error && <div>
                    <p  className="error-message-location">{errorMessage.title}</p>
                    <p  className="error-message-location">{errorMessage.description}</p>
                    </div>}
            </div>
        </div>
    );
};

export default CityPopup;